import { observer } from "mobx-react-lite";
import React from "react";

import Svg from "../../../components/svg/Svg";
import { Email, Address, TelFax } from "../../../components/svg/svgImageList";
import { TermsAndConditions } from "../../../components/terms-and-conditions/TermsAndConditions";
import { translationService } from "../../../services/translation/TranslationService";

interface StaticInfoProps {
  svg: React.FunctionComponent;
  descriptionKey: string;
}

export const HelpContact = observer(() => {
  return (
    <>
      <div className="contact-title">{translationService.translate("HelpPage.contact.title")}</div>
      <div>
        <div className="contact-text">{translationService.translate("HelpPage.contact.text")}</div>
        <TermsAndConditions />
      </div>
      <div className="contact-details">
        <StaticInfo svg={Address} descriptionKey="general.contact.address" />
        <StaticInfo svg={Email} descriptionKey="general.contact.email" />
        <StaticInfo svg={TelFax} descriptionKey="general.contact.telFax" />
      </div>
    </>
  );
});

const StaticInfo = (props: StaticInfoProps) => {
  const { svg, descriptionKey } = props;
  return (
    <div className="static-info-item">
      <Svg svg={svg} width={50} height={50} />
      <pre>{translationService.translate(descriptionKey)}</pre>
    </div>
  );
};
